import { render, staticRenderFns } from "./goods-item.vue?vue&type=template&id=1c2b7212&scoped=true&"
import script from "./goods-item.vue?vue&type=script&lang=js&"
export * from "./goods-item.vue?vue&type=script&lang=js&"
import style0 from "./goods-item.vue?vue&type=style&index=0&id=1c2b7212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b7212",
  null
  
)

export default component.exports